import React from "react";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";

import { ContentBox, ContentBoxIcon } from "../../../components";
import { FormattedText } from "../../../components/FormattedText";
import { useStrings } from "../../../localization/localizationHelpers";

export const PitchBeforeYouStartBox = () => {
  const [pitchConceptBeforeYouStartBoxTitle, pitchConceptBeforeYouStartBoxText] = useStrings(
    "pitchConceptBeforeYouStartBoxTitle",
    "pitchConceptBeforeYouStartBoxText"
  );
  return (
    <ContentBox
      titleConfiguration={{
        title: pitchConceptBeforeYouStartBoxTitle,
        icon: ContentBoxIcon.GreenCircle,
        separatorBar: true,
      }}
    >
      <Row>
        <Column>
          <FormattedText text={pitchConceptBeforeYouStartBoxText}></FormattedText>
        </Column>
      </Row>
    </ContentBox>
  );
};
